import { arrondiPrix } from '@/helpers/utils'

export default function afficherPrix2 (valeur) {
  return arrondiPrix(valeur, 2);
}